import { Component, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { IStatusPanelAngularComp } from 'ag-grid-angular';
import { IStatusPanelParams } from "ag-grid-community";
import getDocDefinition from '../pdfExport/docDefinition';
import moment from "moment";
import * as XLSX from 'xlsx';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { ToastrService } from 'ngx-toastr';

pdfMake.vfs = pdfFonts?.pdfMake?.vfs;

@Component({
  selector: 'status-component',
  template: `
    <div class="p-10">
      <mat-checkbox [formControl]="checkboxSummary">Summary</mat-checkbox>
      <button mat-icon-button aria-label="Export to PDF" matTooltip="Export to PDF" (click)="onExportPdf()">
        <mat-icon>description</mat-icon>
      </button>
      <button mat-icon-button aria-label="Export to XLS" matTooltip="Export to XLS" (click)="onExportXls()">
        <mat-icon>insert_drive_file</mat-icon>
      </button>
      <button mat-icon-button aria-label="Printable" matTooltip="Printable" (click)="onPrintable()">
        <mat-icon>print</mat-icon>
      </button>
    </div>
    `,
  styles: [`
    .toast-spinner {
      display: flex;
      align-items: center;
      font-size: 16px;
    }

    .toast-spinner .tspinner {
      border: 4px solid #f3f3f3;
      border-top: 4px solid #3498db; /* Blue color */
      border-radius: 50%;
      width: 20px;
      height: 20px;
      animation: spin 1s linear infinite;
      margin-right: 8px; /* Space between spinner and text */
    }

    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  `],
  encapsulation: ViewEncapsulation.None,
})

export class ExportStatusBarComponent implements IStatusPanelAngularComp {
  private params: IStatusPanelParams;
  private title: string = 'exportPDF';
  private subTitle: string = '';
  private filename: string;
  private pageOritentation: string = 'portrait';
  private rowBold: [];
  private rowPercentage: [];
  private rowTotal: [];
  private notShowingGroupTotal: boolean = false;
  private hideGroupColumn: boolean = false;
  private show;

  checkboxSummary = new FormControl();

  constructor(private toastr: ToastrService) { }

  agInit(params: IStatusPanelParams): void {
    this.params = params;
  }

  getPrintParams() {
    this.filename = (this.filename) ? this.filename : this.title;
    const currentDate = moment().format('YYYY-MM-DD');
    const currentTime = moment().format('hh:mm:ss A');
    return {
      PDF_TITLE: this.title,
      PDF_SUB_TITLE: this.subTitle,
      PDF_GENERATED_ON: `Generated on ${currentDate} ${currentTime}`,
      PDF_HEADER_COLOR: "#f8f8f8",
      PDF_INNER_BORDER_COLOR: "#dde2eb",
      PDF_OUTER_BORDER_COLOR: "#babfc7",
      PDF_LOGO: "",
      PDF_PAGE_ORITENTATION: "portrait",
      PDF_WITH_HEADER_IMAGE: false,
      PDF_WITH_FOOTER_PAGE_COUNT: false,
      PDF_HEADER_HEIGHT: 10,
      PDF_ROW_HEIGHT: 10,
      PDF_ODD_BKG_COLOR: "#fcfcfc",
      PDF_EVEN_BKG_COLOR: "#ffffff",
      PDF_WITH_CELL_FORMATTING: true,
      PDF_WITH_COLUMNS_AS_LINKS: true,
      PDF_SELECTED_ROWS_ONLY: false,
      PDF_FILENAME: this.title.replace(/\s/g, '') + "_" + currentDate,
      PDF_ROW_BOLD: this.rowBold,
      PDF_ROW_PERCENTAGE: this.rowPercentage,
      PDF_ROW_TOTAL: this.rowTotal,
      PDF_NOT_SHOWING_GROUP_TOTAL: this.notShowingGroupTotal,
      PDF_HIDE_GROUP_COLUMN: this.hideGroupColumn,
      PDF_SUMMARY: this.checkboxSummary.value
    };
  }

  onExportPdf() {
    const toastrRef = this.toastr.info(
      `<div class="toast-spinner">
         <div class="tspinner"></div>
         <span>Exporting PDF......</span>
       </div>`,
      '', // Optional title
      {
        enableHtml: true, // Enable HTML content in the toast
        timeOut: 0, // Set to 0 for an indefinite spinner
        //closeButton: true, // Allow manual closure
      }
    );

    setTimeout(() => {
      const docDefinition = getDocDefinition(this.getPrintParams(), this.params.api, this.params.columnApi);
      console.log(docDefinition);
      pdfMake.createPdf(docDefinition).getBlob((blob) => {
        // Create an object URL for the PDF
        const url = URL.createObjectURL(blob);

        // Open the PDF in a new window
        window.open(url);

        this.toastr.clear(toastrRef.toastId);
      });
    }, 200);
  }

  onExportXls() {
    // this.params.api.exportDataAsExcel();
    const xlsxData = [];
   
    const docDefinition = getDocDefinition(this.getPrintParams(), this.params.api, this.params.columnApi);
    console.log(docDefinition);
    if (docDefinition && docDefinition.content) {
      docDefinition.content.forEach(content => {
        if (content) {
          if (content.style === 'myTable') {
            const body = content.table.body;
            body.forEach((row, rowIndex) => {
              const xlsxRow = [];
              row.forEach((cell, cellIndex) => {
                if (this.isObjectEmpty(cell) || cell.temp) {
                  xlsxRow.push("");
                }
                else if (cell.style === 'tableHeader') {
                  xlsxRow.push(cell.text);
                }
                else if (cell.style === 'tableCell') {
                  const pdfOptions = cell.pdfExportOptions;
                  let cellText = cell.text;
                  if (pdfOptions && pdfOptions.styles && pdfOptions.styles.currencyFormatter === "true") {
                    cellText = this.convertToNumber(cell.text);
                  }
                  xlsxRow.push(cellText);
                }
                else if (cell.style === 'tableFooter') {
                  const pdfOptions = cell.pdfExportOptions;
                  let cellText = cell.text;
                  if (pdfOptions && pdfOptions.styles && pdfOptions.styles.currencyFormatter === "true") {
                    cellText = this.convertToNumber(cell.text);
                  }
                  xlsxRow.push(cellText);
                }
              });
              xlsxData.push(xlsxRow);
            });
          }
        }
      })
    }

    const filename = this.title.replace(/\n/g, '');
    const worksheet = XLSX.utils.aoa_to_sheet(xlsxData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, `Sheet1`);

    // Save the workbook as XLSX file
    XLSX.writeFile(workbook, `${filename}.xlsx`);
  }

  onPrintable() {
    console.log(this.getPrintParams());
    const docDefinition = getDocDefinition(this.getPrintParams(), this.params.api, this.params.columnApi);
    console.log(docDefinition);

    const htmlHeader = `<html>
        ${this.getStyle()}
        <head>
        <title>${this.title}</title>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.17.0/xlsx.full.min.js"></script>
        </head>
        <body>
        <table width='100%' border='0' bgcolor='white'>
        <tr>
        <td valign='top' align='center' class='bold-text'>`;
    let title = "";
    let exportLink = `<table class='noborder'><tr><td align='right'>
        <img src='assets/images/exportxls.png' width='16px'><a href='#' class='smalllink' onclick='exportToCSV()'>Export CSV</a>
        &nbsp;<img src='assets/images/exportxls.png' width='16px'><a href='#' class='smalllink' onclick='exportToXLSX()'>Export XLS</a>
        </td></tr></table>`;
    let tableContent = "<table class='printable' id='dataTable'><thead>";
    let headerIndex = 0;
    if (docDefinition && docDefinition.content) {
      docDefinition.content.forEach(content => {
        if (content) {
          if (content.style === 'header') {
            headerIndex += 1;
            if (headerIndex === 1) {
              title += `<font size='+1'>${content.text}</font><br>`;
            }
            else {
              title += `<font size='-1'>${content.text}</font><br>`;
            }
          }
          else if (content.style === 'myTable') {
            const body = content.table.body;
            body.forEach((row, rowIndex) => {
              tableContent += '<tr>';
              let isColspan = false;
              row.forEach((cell, cellIndex) => {
                const colSpan = cell.colSpan ? `colSpan=${cell.colSpan}` : '';
                if (this.isObjectEmpty(cell) && !isColspan) {
                  tableContent += `<th align=""></th>`;
                }
                else if (cell.style === 'tableHeader') {
                  const pdfExportOptions = cell.pdfExportOptions;
                  const alignment = pdfExportOptions && pdfExportOptions.styles && pdfExportOptions.styles.alignment
                    ? pdfExportOptions.styles.alignment : cell.alignment ? cell.alignment : 'left';
                  const width = pdfExportOptions && pdfExportOptions.styles && pdfExportOptions.styles.currencyFormatter
                    ? 'width="10%"' : '';
                  if (!cell.temp) {
                    const cellText = cell.text ? cell.text : '';
                    tableContent += `<th align="${alignment}" ${width} ${colSpan}>${cellText}</th>`;
                  }
                }
                else if (cell.style === 'tableCell') {
                  const alignment = cell.alignment ? cell.alignment : 'left';
                  const bold = cell.bold ? 'class="maincontent"' : '';
                  tableContent += `<td align="${alignment}" ${colSpan} ${bold}>${cell.text}</td>`;
                }
                else if (cell.style === 'tableFooter') {
                  const alignment = cell.alignment ? cell.alignment : 'left';
                  tableContent += `<td align="${alignment}" ${colSpan} class="summary">${cell.text}</td>`;
                }
                if (cell.colSpan) {
                  isColspan = true;
                }
              });
              tableContent += '</tr>';
              if (rowIndex == 0) tableContent += '</thead><tbody>';
            });
          }
        }
      })
    }
    tableContent += "</tbody></table>";
    const htmlScript = this.getScript();
    const htmlFooter = `</body></html>`;
    const htmlContent = htmlHeader + title + `</tbody></table>` + exportLink + tableContent + htmlScript + htmlFooter;
    this.openHtmlInNewPage(htmlContent);
  }

  openHtmlInNewPage(htmlContent: string) {
    const newWindow = window.open('', '_blank');
    // Write the HTML content to the new window
    newWindow.document.write(htmlContent);
    // Close the document to ensure proper rendering
    newWindow.document.close();
  }

  getStyle() {
    const style =
      `<style>
      body {
        font-family: verdana, helvetica, arial, sans-serif;
      }
      a.smalllink {
        text-decoration: none;
        font-size: 100%;
        color: #0048FF;
        font-weight: normal
      }

      a.smalllink:hover {
        text-decoration: underline;
        font-size: 100%;
        color: #c61a1a;
        font-weight: normal
      }
      .bold-text {
	      font-weight: bold;
      }
      table.printable {
        width: 100%;
        font-size: 8px;
        border-spacing: 0;
        border-collapse: collapse;
      }
      table.printable tbody tr:hover {
        background-color: #ffffdd;
      }
      table.printable th {
        color: #000000;
        background-color: #dddddd;
        /*border: 1px solid #808080;*/
        font-size: 110%;
        padding: 3px;
        vertical-align: top;
        /*text-align: center;*/
        word-wrap: break-word;
        border-top: 1px solid;
        border-bottom: 1px solid;
        border-left: none;
        border-right: none;
      }
      table.printable td {
        white-space: pre;
        /*border: 1px solid #808080;*/
        padding: 3px;
        padding-top: 3px;
        padding-bottom: 3px;
        vertical-align: top;
        word-wrap: break-word;
        border-top: none;
        border-bottom: none;
        border-left: none;
        border-right: none;
      }
      table.printable td.summary {
        font-weight: bold;
        font-size: 110%;
        border-top: 1px solid;
        border-bottom: 1px solid;
        border-left: none;
        border-right: none;
      }
      table.printable td.maincontent {
        font-weight: bold;
        font-size: 110%;
      }
      table.noborder {
        width: 100%;
        padding: 0px;
        font-size: 8px;
        border: 0px;
        border-collapse: collapse;
      }
    </style>`;
    return style;
  }

  isObjectEmpty(obj: any): boolean {
    return Object.keys(obj).length === 0;
  }

  getScript() {
    return `<script>
      function exportToCSV() {
        const table = document.getElementById("dataTable");
        const rows = table.getElementsByTagName("tr");
        const csvData = [];

        for (let i = 0; i < rows.length; i++) {
          const row = [], cols = rows[i].querySelectorAll("td, th");
          for (let j = 0; j < cols.length; j++) {
            const cell = cols[j];
            const colspan = parseInt(cell.getAttribute('colspan')) || 1;

            // Handling commas and double quotes within cell values
            const cellText = '"' + cell.innerText.trim().replace(/"/g, '""') + '"';

            // Add the cell text and handle colspan by adding empty cells
            row.push(cellText);
            for (let k = 1; k < colspan; k++) {
                row.push('""'); // Add empty cell for each span
            }
          }
          csvData.push(row.join(","));
        }

        const csvContent = csvData.join("\\n");
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");

        if (navigator.msSaveBlob) { // IE 10+
          navigator.msSaveBlob(blob, "${this.title.replace(/\n/g, '')}.csv");
        } else {
          link.href = URL.createObjectURL(blob);
          link.setAttribute("download", "${this.title.replace(/\n/g, '')}.csv");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }

      function exportToXLSX() {
        const table = document.getElementById("dataTable");
        const rows = table.getElementsByTagName("tr");
        const xlsxData = [];
        const merges = [];

        for (let i = 0; i < rows.length; i++) {
            const row = [], cols = rows[i].querySelectorAll("td, th");
            let colIndex = 0;

            for (let j = 0; j < cols.length; j++) {
                const cell = cols[j];
                const colspan = parseInt(cell.getAttribute('colspan')) || 1;

                // Add cell value
                row[colIndex] = cell.innerText.trim();

                // If colspan is greater than 1, mark cells as merged
                if (colspan > 1) {
                    merges.push({
                        s: { r: i, c: colIndex }, // start cell
                        e: { r: i, c: colIndex + colspan - 1 } // end cell
                    });
                    colIndex += colspan;
                } else {
                    colIndex++;
                }
            }
            xlsxData.push(row);
        }

        const worksheet = XLSX.utils.aoa_to_sheet(xlsxData);
        worksheet['!merges'] = merges;

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        // Save the workbook as XLSX file
        XLSX.writeFile(workbook, "${this.title.replace(/\n/g, '')}.xlsx");
      }

    </script>`
      ;
  }

  setTitle(title: string) {
    this.title = title;
  }

  setSubTitle(subTitle: string) {
    this.subTitle = subTitle;
  }

  setFilename(filename: string) {
    this.filename = filename;
  }

  setPageOritentation(pageOritentation: string) {
    this.pageOritentation = pageOritentation;
  }

  setRowBold(rowBold: []) {
    this.rowBold = rowBold;
  }

  setRowPercentage(rowPercentage: []) {
    this.rowPercentage = rowPercentage;
  }

  setRowTotal(rowTotal: []) {
    this.rowTotal = rowTotal;
  }

  setNotShowingGroupTotal(notShowingGroupTotal: boolean) {
    this.notShowingGroupTotal = notShowingGroupTotal;
  }

  setHideGroupColumn(hideGroupColumn: boolean) {
    this.hideGroupColumn = hideGroupColumn;
  }

  convertToNumber(value) {
    if (typeof value !== 'string') return NaN;

    // Check if the value has a percentage sign
    const hasPercentage = value.includes('%');

    // Check if the value is negative using parentheses
    const isNegative = value.startsWith('(') && value.endsWith(hasPercentage ? ')%' : ')');

    // Remove percentage sign and parentheses if present
    let cleanedString = value.replace(/%/g, '');
    if (isNegative) {
      cleanedString = cleanedString.slice(1, -1); // Remove the parentheses
    }

    // Remove commas from the string
    cleanedString = cleanedString.replace(/,/g, '');

    // Parse the string as a float number
    let number = parseFloat(cleanedString);

    // If it was negative, multiply by -1
    number = isNegative ? -number : number;

    // Append percentage sign if the input had it
    return hasPercentage ? `${number}%` : number;
  }

}
